<script lang="ts">
  import type {ProcessState} from '@/types/common';
  import Icon from '../icon/Icon.svelte';
  export let status: ProcessState;
  export let heading: string = 'Retrieving Data';
  export let content: string = '';
  // Defaults
  let processingMessage: string = 'PROCESSING...';
  let errorMessage: string = 'ERROR';
  let warningMessage: string = 'WARNING';
  let infoMessage: string = 'NOTICE';
  let successMessage: string = 'SUCCESS';
</script>

<div class="flex h-full w-full flex-col items-center justify-center text-center align-middle">
  {#if status == 'BUSY'}
    <Icon name="Spinner" className=" text-primary w-12 h-12 animate-spin" />
    <div class="text-md m-2 block text-gray-500">
      {#if heading != ''}
        {heading}
      {:else}
        {processingMessage}
      {/if}
    </div>
  {:else if status == 'ERROR'}
    <Icon name="Info" className=" text-red-400 w-12 h-12" />
    <div class="m-2 block text-sm text-red-500">
      {#if heading != ''}
        {heading}
      {:else}
        {errorMessage}
      {/if}
    </div>
  {:else if status == 'WARNING'}
    <Icon name="Info" className=" text-orange-400 w-12 h-12" />
    <div class="m-2 block text-sm text-gray-500">
      {#if heading != ''}
        {heading}
      {:else}
        {warningMessage}
      {/if}
    </div>
  {:else if status == 'INFO'}
    <Icon name="Info" className=" text-blue-400 w-12 h-12" />
    <div class="m-2 block text-sm text-gray-500">
      {#if heading != ''}
        {heading}
      {:else}
        {infoMessage}
      {/if}
    </div>
  {:else if status == 'SUCCESS'}
    <Icon name="Info" className=" text-green-400 w-12 h-12" />
    <div class="m-2 block text-sm text-gray-500">
      {#if heading != ''}
        {heading}
      {:else}
        {successMessage}
      {/if}
    </div>
  {/if}
  {#if content != ''}
    <p class="block text-sm text-gray-500">
      {content}
    </p>
  {/if}
</div>
